import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DialogModule } from 'primeng/dialog';

import { ComponentsModule } from '../components/components.module';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { HistoryComponent } from './history/history.component';
import { ExecutionHistoryMapper } from './history/history.mapper';
import { UserProfileComponent } from './user-profile/user-profile.component';

@NgModule({
    imports: [ComponentsModule, RouterModule, DialogModule],
    exports: [ComponentsModule],
    declarations: [
        HomeComponent,
        LoginComponent,
        SignupComponent,
        HistoryComponent,
        UserProfileComponent,
    ],
    providers: [ExecutionHistoryMapper],
})
export class ViewsModule {}
